import { render, staticRenderFns } from "./LetterPreview.vue?vue&type=template&id=253fd153&"
import script from "./LetterPreview.vue?vue&type=script&lang=js&"
export * from "./LetterPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports